<template>
    <div>
        <v-tabs height="47" color="teal" grow   v-model="tab">
            <v-tab slider-color="secondary">
                <v-icon>mdi-shield-star</v-icon>
                Trailers & Categories
            </v-tab>
            <v-tab slider-color="secondary">
                <v-icon>mdi-shield-star</v-icon>
                Regions by Categories & Regions by Trailer
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item>
                <v-container grid-list-xs fluid>
                    <v-row>
                        <v-col cols="6" class="text-center">
                            <label>
                                <h2>Top 5 trailer by cost per kilometer</h2>
                            </label>
                            <Bar :chart-options="chartOptionsX" :chart-data="top" :chart-id="'bar-chart'"
                                dataset-id-key="label" />
                        </v-col>

                        <v-col cols="6" class="text-center">
                            <label>
                                <h2>Bottom 5 trailer by cost per kilometer</h2>
                            </label>
                            <Bar :chart-options="chartOptionsX" :chart-data="bottom" :chart-id="'bar-chart'"
                                dataset-id-key="label" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" class="text-center">
                            <label>
                                <h2>Maintenance costs by trailer</h2>
                            </label>
                            <Bar :chart-options="chartOptions" :chart-data="trailerExp" :chart-id="'bar-chart'"
                                dataset-id-key="label" />
                        </v-col>
                        <v-col cols="6" class="text-center">
                            <label>
                                <h2>Cost per kilometer per trailer</h2>
                            </label>
                            <Bar :chart-options="chartOptions" :chart-data="trailer" :chart-id="'bar-chart'"
                                dataset-id-key="label" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" class="text-center">
                            <label>
                                <h2>Maintenance costs by category</h2>
                            </label>
                            <Bar :chart-options="chartOptions" :chart-data="categoryExp" :chart-id="'bar-chart'"
                                dataset-id-key="label" />
                        </v-col>
                        <v-col cols="6" class="text-center">
                            <label>
                                <h2>Cost per kilometer by category</h2>
                            </label>
                            <Bar :chart-options="chartOptions" :chart-data="category" :chart-id="'bar-chart'"
                                dataset-id-key="label" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-tab-item>
            <v-tab-item>
                <v-container grid-list-xs fluid>
                    <v-row>
                        <v-col cols="6" class="text-center">
                            <label>
                                <h2>Maintenance costs by category</h2>
                            </label>
                            <Bar :chart-options="chartOptions" :chart-data="regionCategoryExp" :chart-id="'bar-chart'"
                                dataset-id-key="label" />
                        </v-col>
                        <v-col cols="6" class="text-center">
                            <label>
                                <h2>Cost per KM by category</h2>
                            </label>
                            <Bar :chart-options="chartOptions" :chart-data="regionCategory" :chart-id="'bar-chart'"
                                dataset-id-key="label" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" class="text-center">
                            <label>
                                <h2>Maintenance costs by region</h2>
                            </label>
                            <Bar :chart-options="chartOptions" :chart-data="regionTrailerExp" :chart-id="'bar-chart'"
                                dataset-id-key="label" />
                        </v-col>
                        <v-col cols="6" class="text-center">
                            <label>
                                <h2>Cost per KM by region</h2>
                            </label>
                            <Bar :chart-options="chartOptions" :chart-data="regionTrailer" :chart-id="'bar-chart'"
                                dataset-id-key="label" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
// import Dispatch from '@/components/Dispatch/Dispatch';
import axios from 'axios';
import { Line as LineChartGenerator } from 'vue-chartjs/legacy';
import { Bar } from 'vue-chartjs/legacy';
import { Doughnut } from 'vue-chartjs/legacy'
import { Scatter } from 'vue-chartjs/legacy'
import VueContext from 'vue-context';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    ArcElement,
    BarElement,
} from 'chart.js';

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    BarElement,
    ArcElement
);
export default {
    props: ['year', 'order', 'typeBy', 'direction'],
    components: {
        LineChart: LineChartGenerator,
        Bar,
        Doughnut,
        Scatter,
        VueContext
    },
    watch: {
        '$store.state.analytics.RollingDate': function () {
            this.getDataDash();
        },
        'typeBy': function () {
            this.getDataDash();
        },
        'order': function () {
            this.getDataDash();
        },

        'direction': function () {
            this.getDataDash();
        },
    },
    data: function () {
        return {
            view: 1,
            dialog: false,
            tab:null,
            top: [],
            bottom: [],
            general: [],
            trailerExp: [],
            category: [],
            categoryExp: [],
            regionTrailer:[],
            regionCategory:[],
            regionTrailerExp:[],
            regionCategoryExp:[],
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            },
            chartOptionsX: {
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: 'y',
                scales: {
                    x: {
                        beginAtZero: true
                    }
                }
            }
        }
    },
    mounted() {
        this.getDataDash();
    },
    methods: {
        drilldown(view) {
            this.view = view;
        },
        getDataDash: function () {
            let str = this.$store;
            str.state.isLoading = true;
            const parms = {
                RollingDate: this.$store.state.analytics.RollingDate,
                RollingDirection: this.direction,
                TypeBy: this.typeBy,
                OrderBy: this.order.id
            }
            axios
                .post('dashboard/maintenance/dash', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.top = this.dataBar(response.data['top'], 'Trailer', 'CostPerKM', 'Cost per kilometer');
                    this.bottom = this.dataBar(response.data['bottom'], 'Trailer', 'CostPerKM', 'Cost per kilometer');
                    this.trailer = this.dataBar(response.data['trailer'], 'Trailer', 'CostPerKM', 'Cost per kilometer');
                    this.trailerExp = this.dataBar(response.data['trailerExp'], 'Trailer', 'MaintExpenses', 'Maint expenses');
                    this.category = this.dataBar(response.data['category'], 'Category', 'CostPerKM', 'Cost per kilometer');
                    this.categoryExp = this.dataBar(response.data['categoryExp'], 'Category', 'MaintExpenses', 'Maint expenses');
                    
                    this.regionTrailer = this.dataBar(response.data['reg_trailer'], 'Region', 'MaintExpenses', 'Cost per kilometer')
                    this.regionTrailerExp = this.dataBar(response.data['reg_trailer_exp'], 'Region', 'CostPerKM', 'Maint expenses')
                    this.regionCategory = this.dataBar(response.data['reg_category'], 'Region', 'CostPerKM', 'Cost per kilometer')
                    this.regionCategoryExp = this.dataBar(response.data['reg_category_exp'], 'Region', 'MaintExpenses', 'Maint expenses')
                    console.log(response.data);
                    str.state.isLoading = false;

                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        dataRegions(data) {
            console.log(data);
            const labels = data.map(x => {
                return x.PrincipalRegion;
            });
            const values = data.map(x => {
                return x.Net;
            });
            const colors = data.map(x => {
                console.log(x.PrincipalRegion);
                return this.getRandomColor();
            });
            const row = {
                labels: labels,
                datasets: [
                    {

                        backgroundColor: colors,
                        data: values
                    }
                ]
            }
            return row;
        },
        dataBar(data, label, value, title) {
            const labels = data.map(x => {
                return x[label];
            });
            const values = data.map(x => {
                return x[value];
            });

            const row = {
                labels: labels,
                datasets: [
                    {
                        data: values,
                        label: title,
                        backgroundColor: '#0D47A1',
                        fill: false
                    }
                ]
            }
            return row;
        },
        dataScatter(data) {
            const rows = data.map(x => {
                return {
                    label: x.Driver,
                    fill: false,
                    borderColor: '#f87979',
                    backgroundColor: '#f87979',
                    data: [
                        {
                            x: x.Expenses,
                            y: x.Revenue
                        }
                    ]
                }
            });
            const datasets = {
                datasets: rows
            }
            return datasets;

        },
        specificRegions(data, cat) {
            var spcReg = [];
            cat.forEach(async spc => {
                const regions = await data.map(x => {
                    return x[spc];
                });
                const labels = await data.map(x => {
                    return x.PrincipalRegion;
                });
                const row = {
                    labels: labels,
                    datasets: [
                        {
                            data: regions,
                            label: spc,
                            backgroundColor: this.getRandomColor(),
                            fill: false
                        }
                    ]
                }
                spcReg.push(row);
            });
            console.log(spcReg);
            return spcReg;
        },
        getRandomColor() {
            return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
        }

    }
};
</script>
